import { render, staticRenderFns } from "./CPSelect.vue?vue&type=template&id=0be463e2&scoped=true"
import script from "./CPSelect.vue?vue&type=script&lang=js"
export * from "./CPSelect.vue?vue&type=script&lang=js"
import style0 from "./CPSelect.vue?vue&type=style&index=0&id=0be463e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be463e2",
  null
  
)

export default component.exports